import React from 'react';
import {ProductsProvider} from '../Context/Products/ProductsContext';
import Selector from '../Product/Selector';
import {TaopixCore} from '@taopix/taopix-core/dist/types/types';

const ProductsView = ({core}: {core: TaopixCore}) => {
  return (
    <ProductsProvider core={core}>
      <Selector />
    </ProductsProvider>
  );
};

export default ProductsView;
